export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'browser' // browser,wechat
    }
  },

  data() {
    return {
      visible: this.modelValue
    };
  },
  emits: ['update:modelValue'],
  computed: {},
  methods: {
    destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$el.parentNode.removeChild(this.$el);
    },
    close() {
      this.visible = false;
      this.$emit('update:modelValue', false);
      this.destroyElement();
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {
    modelValue(newValue) {
      this.visible = newValue;
    },
    visible(newValue) {
      this.$emit('update:modelValue', newValue);
    }
  }
};